<template>
  <header class="header header--2">
    <div class="container">
      <div class="section-wrapper">
          <div class="header__content">
            <navbar-logo></navbar-logo>
            <button v-if="!isTwa" type="button" class="btn btn-default btn-icon mobile-navbar__toggle d-lg-none" @click="toggleMenu">
              Menu
              <svg v-if="isMenuOpen" width="24" height="24">
                <use href="/static/images/sprite/sprite.svg#cross-icon"></use>
              </svg>
              <svg v-else width="24" height="24">
                <use href="/static/images/sprite/sprite.svg#burger-icon"></use>
              </svg>
            </button>
            <login-btn v-else :is-full="false" class="d-lg-none"/>

            <search-form
              :class="['content-search',
                {'opacity-0': isMenuOpen, 'd-none d-lg-flex': isTwa}
              ]"
            />
          </div>

          <div class="navbar d-none d-lg-flex">
              <main-nav></main-nav>

              <div class="side-menu">
                  <profile-link></profile-link>
                  <login-btn></login-btn>
              </div>
          </div>
          <div class="navbar navbar-mobile d-lg-none" :class="{ open: isMenuOpen }">
              <main-nav></main-nav>

            <div class="side-menu">
              <profile-link></profile-link>
              <login-btn></login-btn>
            </div>
          </div>
      </div>
    </div>
  </header>

  <main-nav-twa v-if="isTwa"/>
</template>

<script>
import NavbarLogo from "./parts/NavbarLogo.vue";
import SearchForm from "./parts/SearchForm.vue";
import LanguageSwitcher from "./parts/LanguageSwitcher.vue";
import IconNav from "./parts/IconNav.vue";
import ProfileLink from "./parts/ProfileLink.vue";
import LoginBtn from "./parts/LoginBtn.vue";
import MainNav from "./parts/MainNav.vue";
import MainNavTwa from '@/components/layouts/header/parts/MainNavTwa.vue';
import { isTWA } from '@/helpers/detectTWA'
export default {
    components: {
      MainNavTwa,
        NavbarLogo,
        SearchForm,
        LanguageSwitcher,
        IconNav,
        ProfileLink,
        LoginBtn,
        MainNav,
    },
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    }
  },
  computed: {
    isTwa() {
      return isTWA()
    }
  }
};
</script>

<style
  lang="scss"
  scoped
>
$logo-width: 207px;
$search-width: 413px;

.header {
  position: relative;
  margin: 20px 0;

  .section-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__content {
    display: grid;
    grid-template-columns: $logo-width $search-width;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }

  .navbar {
    padding: 0;
  }

  :deep(.menu) {
    display: flex;
    gap: 8px;
  }

  .side-menu {
    display: flex;
    gap: 8px;
    margin-left: auto;
  }

  .mobile-navbar__toggle {
    width: max-content;
    margin-left: auto;
  }
  .navbar-mobile {
    display: none;
    position: absolute;
    background: $white;
    top: 75px;
    left: 0;
    right: 0;
    padding: 60px 16px 16px;
    border-radius: 0 0 32px 32px;
    border: 1px solid $green-shade;
    border-top: 0;
    height: calc(100vh - 116px);
    z-index: 5;
    flex-direction: column;
    justify-content: space-between;

    :deep(.menu) {
      flex-direction: column;
      width: 100%;

      .menu__item {
        width: 100%;
      }
    }
    .side-menu {
      display: flex;
      flex-direction: column;
      width: 100%;

      :deep(.btn) {
        width: 100%;
      }
    }

    &.open {
      display: flex;
    }
  }

  @media (max-width: $breakpoint-lg) {
    &__content {
      grid-template-columns: minmax(100px, $logo-width) auto;
    }
    .content-search {
      grid-column: 1/3;
    }
  }
}
</style>